/**
 * @fileoverview DELETE handler for the "/apps/catalogs/:catalog_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdCacheKeys } from "./constants";
import type { DeleteAppsCatalogsCatalogIdProps, AppsCatalogsCatalogIdDeleteResult } from "./types";

export const deleteAppsCatalogsCatalogId = reactQueryMutationAdapter(
  appsCatalogsCatalogIdCacheKeys,
  (props: DeleteAppsCatalogsCatalogIdProps): Promise<AppsCatalogsCatalogIdDeleteResult> => {
    // manipulate props here as needed {  }

    return fetch(`/apps/catalogs/${props.catalogId}`, "DELETE", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
